import icon from 'vue-svgicon';

icon.register({
    'bold/question-circle': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0zm0 19a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 12 19zm1.6-6.08a1 1 0 0 0-.6.917 1 1 0 1 1-2 0 3 3 0 0 1 1.8-2.75A2 2 0 1 0 10 9.255a1 1 0 1 1-2 0 4 4 0 1 1 5.6 3.666z"/>`,
    },
});
